import { render, staticRenderFns } from "./ConfigurationNameTranslations.vue?vue&type=template&id=5d558d1d&scoped=true&"
import script from "./ConfigurationNameTranslations.vue?vue&type=script&lang=js&"
export * from "./ConfigurationNameTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d558d1d",
  null
  
)

export default component.exports